// EQM2040_R01 - 용수사용. 전력량 등록
import { defaultTqcDailyInspectionDto, TqcDailyInspectionDto } from "src/dtos/tqcDailyInspection/tqcDailyInspectionDto";

export interface EQM2040_R01Dto extends TqcDailyInspectionDto {
	listLength?: number;
	refetchListLength?: number;
	inspectionMonth?: string;
	
	// 기본 정보
	compNm: string;					// 사업장명
	dayOfWeek: string;				// 요일

	laboratory01: number;		// 연구실 온도 inspectionType row LABORATORY 데이터
	laboratory02: number;		// 연구실 습도 inspectionType row LABORATORY 데이터
	pharmacy01: number;			// 약품실 온도 inspectionType row PHARMACY 데이터
	pharmacy02: number;			// 약품실 습도 inspectionType row PHARMACY 데이터
	xrayRoom01: number;			// X선실 온도 inspectionType row XRAY_ROOM 데이터
	xrayRoom02: number;			// X선실 습도 inspectionType row XRAY_ROOM 데이터

}

// 기본값 상수
export const defaultEQM2040_R01Dto: EQM2040_R01Dto = {
	...defaultTqcDailyInspectionDto,
	listLength: 0,
	refetchListLength: 0,
	inspectionMonth: '',
	
	compNm: '',
	dayOfWeek: '',

	laboratory01: 0,
	laboratory02: 0,
	pharmacy01: 0,
	pharmacy02: 0,
	xrayRoom01: 0,
	xrayRoom02: 0,

};

